/* eslint-disable no-console */
import {PlusOutlined, ArrowUpOutlined, MinusOutlined} from '@ant-design/icons';
import {Button, Col} from 'antd';
import React from 'react';
import {useNavigate, useParams, useSearchParams} from 'react-router-dom';

import {allRoutes} from '../../../constants/Routes';

interface PillarProps {
  item: {
    icon: string;
    title: string;
    content: string;
    route: string;
    timel?: Array<{
      key: string;
      ptitle: string;
    }>;
  };
  colSpan: number;
  data: {
    modules?: number;
    totalQuestions?: number;
    questionsAnswered?: number;
    completion?: number;
  };
  isExpanded: boolean;
  onToggle: () => void;
}

const Pillar: React.FC<PillarProps> = ({item, data, isExpanded, onToggle}) => {
  const {framework} = useParams();

  const {icon, title, content, route, timel} = item;

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const selectedYear = searchParams.get('selectedYear');

  return (
    <Col className="gutter-row" span={24}>
      <div className={`pillar-card ${isExpanded ? 'expanded' : ''}`}>
        <div className="pillar-image-section">
          <img id="image" src={icon} alt="Logo" className="pillar-image" />
        </div>

        <div className="pillar-content-section">
          <div className="pillar-title">{title}</div>
          <div className="pillar-description">{content}</div>
        </div>

        <div className="pillar-progress-section">
          <div className="pillar-progress-content">
            <div
              className="module-count-icon"
              onClick={onToggle}
              style={{cursor: 'pointer'}}
            >
              {isExpanded ? <MinusOutlined /> : <PlusOutlined />}
            </div>
            <div className="pillar-module-info">
              <span className="module-count">
                {data?.modules ?? 0} Modules, {data?.totalQuestions ?? 0}{' '}
                Questions
              </span>
              <div className="pillar-progress-bar">
                <div
                  className="pillar-progress-fill"
                  style={{width: `${data?.completion ?? 0}%`}}
                ></div>
              </div>
            </div>
            <span className="pillar-progress-text">
              {data?.completion ?? 0}%
            </span>
          </div>
          <div className="pillar-progress-container">
            <Button
              className="pillar-navigation-button"
              onClick={() => {
                navigate(
                  `${allRoutes.ESG.FRAMEWORK}/${framework}/${route}?selectedYear=${selectedYear}`,
                  {state: data}
                );
              }}
              icon={<ArrowUpOutlined className="diagonal-arrow" />}
            />
          </div>
        </div>
      </div>

      {/* Expandable Modules Section */}
      {isExpanded && (
        <div className="pillar-expanded-section">
          <div className="pillar-expanded-content">
            <div className="questions-answered-section">
              <div className="questions-answered-number">
                {data?.questionsAnswered ?? 43}/{data?.totalQuestions ?? 2034}
              </div>
              <div className="questions-answered-label">Questions Answered</div>
            </div>

            <div className="modules-section">
              <div className="modules-title">Modules:</div>
              <div className="modules-list">
                {timel?.map((module) => (
                  <div key={module.key} className="module-tag">
                    {module.ptitle}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </Col>
  );
};

export default Pillar;
